namespace $.$$ {

	$mol_style_define( $shm_hitalama_profile_badge, {
		alignItems: 'center',
		gap: $mol_gap.text,
		minWidth: 0,

		Avatar: {
			width: '1.5rem',
			height: '1.5rem',
			borderRadius: '50%',
			objectFit: 'cover',
			flex: { shrink: 0 },
		},

		Name: {
			minWidth: 0,
			overflow: 'hidden',
			textOverflow: 'ellipsis',
		},
	} )

}

